"use strict";

exports.__esModule = true;
exports.getCachedObservableQuery = getCachedObservableQuery;
exports.invalidateCachedObservableQuery = invalidateCachedObservableQuery;
exports.getCacheKey = getCacheKey;

var _objectToKey = _interopRequireDefault(require("./objectToKey"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Source https://github.com/trojanowski/react-apollo-hooks/blob/master/src/queryCache.js


var cachedQueriesByClient = new WeakMap();

function getCachedObservableQuery(client, options) {
  var queriesForClient = getCachedQueriesForClient(client);
  var cacheKey = getCacheKey(options);
  var observableQuery = queriesForClient.get(cacheKey);

  if (observableQuery == null) {
    observableQuery = client.watchQuery(options); // this is added to only fetch once

    var subscription = observableQuery.subscribe(function () {});
    observableQuery._fetchOnceSubscription = subscription;
    queriesForClient.set(cacheKey, observableQuery);
  }

  return observableQuery;
}

function invalidateCachedObservableQuery(client, options) {
  var queriesForClient = getCachedQueriesForClient(client);
  var currentObservable = getCachedObservableQuery(client, options);

  if (currentObservable && currentObservable._fetchOnceSubscription) {
    currentObservable._fetchOnceSubscription.unsubscribe();
  }

  var cacheKey = getCacheKey(options);
  queriesForClient.delete(cacheKey);
}

function getCachedQueriesForClient(client) {
  var queriesForClient = cachedQueriesByClient.get(client);

  if (queriesForClient == null) {
    queriesForClient = new Map();
    cachedQueriesByClient.set(client, queriesForClient);
  }

  return queriesForClient;
}

function getCacheKey(options) {
  return (0, _objectToKey.default)(options);
}